import { Button, CircularProgress } from "@mui/material";

export function LoaderButton(props){
    const {progressColor,buttonContent,enableLoader,size,variant,type,sx,...rest} = props
    return <Button  disabled={enableLoader}  sx={{textTransform:"capitalize",fontFamily:"Figtree",...sx}} {...rest} size={size? size : 'medium'} variant={variant} type={type ? type : 'submit'}    fullWidth>{ enableLoader ? <CircularProgress size={25} sx={{color:progressColor||"white"}} /> :  buttonContent}</Button>
}